<xproj-dashboard #dashboard [editMode]="false" [showDashboardSettings]="false"  [enableExport]="true" (onWidgetExport)="onWidgetExport($event)"
[responsiveWidth]="responsiveWidth" [dashboardOutputParameters]="dashboardOutputParameters"></xproj-dashboard>
